var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcLlv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 36.9862L33.5214 5.38232L46.5008 18.3957L14.9794 49.9995",
    stroke: "#D83D34",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 49.9994V36.9861L14.9794 49.9994H2Z",
    stroke: "#D83D34",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49072 43.493L40.0121 11.8892",
    stroke: "#D83D34",
    strokeWidth: 2.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5552 5.49417C33.7948 5.17977 34.0549 4.88167 34.3339 4.60182C36.0815 2.91349 38.4196 1.97949 40.8464 2.00034C43.2731 2.0212 45.5949 2.99525 47.3133 4.71336C48.1638 5.55548 48.839 6.55851 49.2999 7.66428C49.7607 8.77005 49.998 9.95655 49.998 11.155C49.998 12.3534 49.7607 13.5399 49.2999 14.6457C48.839 15.7514 48.1638 16.7545 47.3133 17.5966C47.039 17.8814 46.7413 18.1426 46.4233 18.3774",
    stroke: "#D83D34",
    strokeWidth: 2.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLlv);
export default __webpack_public_path__ + "static/media/ic-llv.e3d35ff91eba83d4ee8b79ab0cc96b17.svg";
export { ForwardRef as ReactComponent };